export const ACTIONS_VESR = {
	VESR_DASHBOARD: 'vesr_dashboard',
	VESR_INCIDENTS: 'vesr_incidents',
	VESR_INCIDENTS_CREATE: 'vesr_incidents_create',
	VESR_INCIDENTS_MANAGE: 'vesr_incidents_manage',
	VESR_ELECTION_PULSE: 'vesr_election_pulse',
	VESR_COMMUNICATION: 'vesr_communication',
	VESR_MEETINGS: 'vesr_meetings',
	VESR_MEETINGS_CREATE: 'vesr_meetings_create',
	VESR_MESSAGING: 'vesr_messaging',
	VESR_MEDIA: 'vesr_media',
	VESR_MEDIA_UPLOAD: 'vesr_media_upload',
	VESR_INTEGRATION: 'vesr_integration',
	VESR_EFLOC: 'vesr_efloc',
	VESR_USERS: 'vesr_users',
	VESR_SETTINGS: 'vesr_settings',
	VESR_REPORTS: 'vesr_reports',
	VESR_FEEDBACK: 'vesr_feedback',
	VESR_AUDIT_LOGS: 'vesr_audit_logs',
	VESR_ANALYTICS: 'vesr_analytics',
} as const;
